import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import "./../../Style/AddPurchaseTotal.scss";
import "./../../Style/TableStyle.scss";
import "../ReceivablesCRUD/ReceivablesPage.scss";
import "./CapitalDepositCRUD.scss";
import { deleteAlert, errorAlert } from "../../Components/Alerts";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { AiFillAppstore } from "react-icons/ai";
import ReusableServerDataGrid from "../../Components/ReusableServerDataGrid";
import { CapitalDepositGridHeader } from "./CapitalDepositGrid";
import { useHistory } from "react-router-dom";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import CrudPageHeader from "../../Components/CrudPageHeader";
import { AddElementsButton } from "../../Components/AddElementsButton";
import { formatDate } from "../../Components/formatDate";
import CapitalDepositViewModal from "./CapitalDepositViewModal";

export default function CapitalDepositePage() {
  const history = useHistory();
  const headers = authHeader();
  const { fiscalYear } = useContext(FiscalYearContext);

  const [data, setData] = useState([]);
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
  const [sortModel, setSortModel] = useState([]);
  const [filterModel, setFilterModel] = useState({ items: [] });
  const [quickFilter, setQuickFilter] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [totals, setTotals] = useState({ Total: 0 });
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewData, setViewData] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(ApiLink.API_URL + "CapitalDeposite/getAllCapitalDepositData", {
        headers,
        params: {
          fiscalYear,
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          sort: JSON.stringify(sortModel),
          filter: JSON.stringify(filterModel.items),
          quickFilter: quickFilter.join(" "),
        },
      });

      setData(response.data.items || []);
      setRowCount(response.data.total || 0);
    } catch {
      errorAlert("Gabim në marrjen e listës së deponimeve të kapitalit.");
    } finally {
      setLoading(false);
    }
  };

  const fetchTotals = async () => {
    try {
      const response = await axios.get(ApiLink.API_URL + "CapitalDeposite/getTotals", {
        headers,
        params: {
          fiscalYear,
          filter: JSON.stringify(filterModel.items),
          quickFilter: quickFilter.join(" "),
        },
      });

      setTotals(response.data || { Total: 0 });
    } catch {
      errorAlert("Gabim në marrjen e totaleve të deponimeve.");
    }
  };

  const handleDelete = async (deleteItemId) => {
    try {
      await axios.delete(ApiLink.API_URL + "CapitalDeposite" + `/${deleteItemId}`, { headers });
      deleteAlert("Capital Deposit Deleted Successfully");
      fetchData();
      fetchTotals();
    } catch {
      deleteAlert("Capital Deposit can not be deleted");
    }
  };

  const handleEdit = (item) => {
    history.push(`/money/editCapitalDeposit/${item.TransactionID}`);
  };

  const handleView = (item) => {
    setViewData(item);
    setShowViewModal(true);
  };

  const rows = data.map((item, index) => ({
    id: item.TransactionID ?? index + 1,
    rowNumber: paginationModel.page * paginationModel.pageSize + index + 1,
    inv: `CAD-${fiscalYear}-${item.InvoiceNr || ""}`,
    date: formatDate(item.Date),
    client: item.AccountName_AccountID,
    account: item.AccountName_PaymentOptions,
    amount: item.Total,
    deleteItemId: item.TransactionID,
    rowInfo: item,
  }));

  useEffect(() => {
    fetchData();
  }, [paginationModel, sortModel, filterModel, quickFilter, fiscalYear]);

  useEffect(() => {
    fetchTotals();
  }, [filterModel, quickFilter, fiscalYear]);

  return (
    <div className="Crud__Container REC__page CPD__page">
      <div className="shfaqePermbajtjen REC__content">
        <CrudPageHeader
          icon={AiFillAppstore}
          title="Deponimet e Kapitalit"
          description="Forma e Deponimit të Kapitalit: menaxhoni, shtoni, editoni dhe fshini deponime kapitali."
          tutorialUrl="https://www.youtube.com/@Accountree"
          tutorialLabel="Shiko Tutorialin"
          className="REC__header"
          action={
            <AddElementsButton
              text="Krijo Deponim"
              icon="bi bi-plus-circle"
              className="button-68"
              onClick={() => history.push("/money/addCapitalDeposit")}
            />
          }
        />

        <ReusableServerDataGrid
          columns={CapitalDepositGridHeader}
          rows={rows}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDelete}
          showViewAction={true}
          actionsMinWidth={90}
          actionsFlex={0.75}
          height={620}
          rowCount={rowCount}
          loading={loading}
          paginationModel={paginationModel}
          setPaginationModel={setPaginationModel}
          sortModel={sortModel}
          setSortModel={setSortModel}
          filterModel={filterModel}
          setFilterModel={setFilterModel}
          quickFilter={quickFilter}
          setQuickFilter={setQuickFilter}
          summaryFooter={{
            labelField: "client",
            label: "Totali",
            values: {
              amount: Number(totals.Total || 0).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }),
            },
          }}
        />

        <CapitalDepositViewModal
          show={showViewModal}
          onHide={() => setShowViewModal(false)}
          data={viewData}
        />
      </div>
    </div>
  );
}
